import { Component, OnInit } from '@angular/core';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { Router } from '@angular/router';
import { SocketioService } from 'src/app/services/socketio.service';

@Component({
  selector: 'app-sidebarlanding',
  templateUrl: './sidebarlanding.component.html',
  styleUrls: ['./sidebarlanding.component.css']
})
export class SidebarlandingComponent implements OnInit {
  isMenuOpen = true;
  contentMargin = 240;
  nombreUsuario = '';
  nombreempresa = '';
  useradministrador = false;
  emailempresa = '';
  alias = '';
  empresa = '';
  usuarioGestor = false;
  usuarioslanding = false;
  iconoconectadoaredconapesca= true;
  modoMtto=false;
  

  constructor(
    private Loginservicio: UsuarioService,
    private router: Router,
    private socketService: SocketioService,
  ) { }


  onToolbarMenuToggle() {
  //  console.log('On toolbar toggled', this.isMenuOpen);
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }

  ngOnInit() {


    const modomantenimiento = async ()=>{
      let modoto=   localStorage.getItem("servidormtto") ;
      this.modoMtto = Boolean(JSON.parse(modoto)); 
         
     }
    
     // aqui asignaremos otra color a lel logo de sportfishing y parpadeando
     modomantenimiento();

    if (localStorage.getItem('pagina')=="GESTOR"){
      this.usuarioGestor=true;
    } else {
      this.usuarioslanding=true;
    }

    this.nombreUsuario = this.Loginservicio.nombredelusuario;
    this.useradministrador = this.Loginservicio.administrador;
    this.nombreempresa = this.Loginservicio.nombreempresa;
    this.emailempresa = this.Loginservicio.emailempresa;

    this.alias = this.Loginservicio.alias;
  //  console.log ('*******alias', this.Loginservicio.alias);




  this.socketService.listen("modomantenimiento").subscribe((data) => {
    const jsonstring = JSON.stringify(data);
    const obj = JSON.parse(jsonstring);

    // tomamos le valor d el avariable
    // falso quore decir que ya salio dle modo mantenimienot
    // true que enttro a mantenimiento

    if (obj.valor =='true' ){
      localStorage.setItem(
        "servidormtto",
        "true"
      );
      this.modoMtto = true; 

    } else {

      localStorage.setItem(
        "servidormtto",
        "false"
      );

      this.modoMtto = false; 
    }

   




    
  });

  }


  abrePermisos() {
    this.router.navigate(['../landing']);
  }


  abrelistadopermisosSolicitados() {
    this.router.navigate(['../prepago']);
  }


  gestorabreAgenciasexpedidoreas() {
    this.router.navigate(['../gestorprepago']);
  }


  abreAgenciasexpedidoreas() {
    this.router.navigate(['../gestoresmenu']);
  }


  logout(){
    localStorage.clear();
    this.router.navigate(['']);
    // window.open("https://www.sportfishingmx.com");

  }


  abrelistausuarios( ) {


     this.router.navigate(['../listausuarios']);


  }

}
